import React from 'react';
import { Alert } from '@mui/material';

import { getBankLabel } from '../../../../constants/thaiBanks';
export function CustomerBankInfo({ customer, labelPrefix, sx }) {
  if (!customer?.bank) return null;
  const { bank_name: bankName, account_name: accountName, account_number: accountNumber, branch } = customer.bank;

  return (
    <Alert severity="info" sx={sx}>
      {labelPrefix}
      ธนาคาร: {getBankLabel(bankName) || '-'} /
      {' '}ชื่อบัญชี: {accountName || '-'} /
      {' '}เลขบัญชี: {accountNumber || '-'} /
      {' '}สาขา: {branch || '-'}
    </Alert>
  );
}

export default CustomerBankInfo;
